<template>
    <v-system-bar style="z-index:100;"
        color="teal accent-4"
        flat
        height="48"
        app
    >
        <v-toolbar-title
            style="color:white"
        >
            <!--<a style="color: white; text-decoration: none;" href="/documents/dashboard">DX-Sign</a>-->
           <a style="color: white; text-decoration: none;" href="/documents/dashboard">
             <img :src="logo" alt="logo画像" style="height: 40px; margin-left: 10px; margin-top: 8px;"></img>
            </a>
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <slot name="account_menu"></slot>

    </v-system-bar>
</template>

<script>
    import logo from '../../images/logo.png'
    export default {
        data() {
            return {
                logo: logo
              }
        }
    };
</script>